import { SegmentDefinition } from "./SegmentDefinition";

export class Company {
    code: string;
    name: string;
    themeName: string | undefined;
    segmentDefinition: SegmentDefinition | undefined;

    constructor(
        code: string,
        name: string,
        themeName: string | undefined,
        segmentDefinition: SegmentDefinition | undefined
    ) {
        this.code = code;
        this.name = name;
        this.themeName = themeName;
        this.segmentDefinition = segmentDefinition;
    }
}
